import React from 'react';
import SimpleBar from '../../../../components/third-party/SimpleBar';
import Navigation from './navigation';

const DrawerContent = () => {
  return (
    <SimpleBar
      sx={{
        '& .simplebar-content': {
          display: 'flex',
          flexDirection: 'column',
        },
      }}>
      <Navigation />
    </SimpleBar>
  );
};

export default DrawerContent;
